import { makePaymentUrlData, sidebarMakePaymentElem } from './modules/payments/modal/constants'
import paymentDataLoad from './modules/payments/load'
import { paymentModalSuccess, paymentModalFailure } from './modules/payments/modal/request'
import paymentModalOpen from './modules/payments/modal/open'
import { makePaymentDashboardElem, makePaymentDashboardUrlData } from './modules/payments/dashboard/constants'
import { paymentDashboardSuccess, paymentDashboardFailure } from './modules/payments/dashboard/request'
import { paymentDashboardButtonDisable } from './modules/payments/dashboard/button'

function openPaymentModal () {
  paymentModalOpen()
  paymentDataLoad(makePaymentUrlData, paymentModalSuccess, paymentModalFailure)
}

function attachMakePaymentClick () {
  sidebarMakePaymentElem.on('click', function (evt) {
    evt.preventDefault()

    openPaymentModal()
  })
}

function attachMakePaymentDashboard () {
  if (makePaymentDashboardElem.length == 0) {
    return
  }

  paymentDashboardButtonDisable()
  paymentDataLoad(makePaymentDashboardUrlData, paymentDashboardSuccess, paymentDashboardFailure)
}

document.addEventListener('DOMContentLoaded', function () {
  attachMakePaymentClick()
  attachMakePaymentDashboard()
})
